import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase';

export function logLogin(userId) {
  if (analytics) {
    logEvent(analytics, 'login', { method: 'email', user_id: userId, timestamp: new Date().toISOString() });
  }
}

export function logSessionStart() {
  if (analytics) {
    logEvent(analytics, 'session_start', { timestamp: new Date().toISOString() });
  }
}

export function logSessionEnd(durationMs) {
  if (analytics) {
    logEvent(analytics, 'session_end', { duration_ms: durationMs, timestamp: new Date().toISOString() });
  }
}
